import React from 'react'
import _ from 'lodashParts'

class Button extends React.Component {
    constructor(props) {
        super(props)
        this.execCommand = () => this.props.execCommand(this.props.cmdName)
    }

    render() {
        return (
            <button data-aid={this.props.automationId} style={this.props.style} className={'richtext-button ' + (this.props.className || '') } onClick={() => this.props.onClick()} disabled={this.props.disabled ? 'disabled' : ''}>
                {this.props.children}
            </button>
        )
    }
}

Button.defaultProps = {
    onClick: _.noop,
    disabled: false
}

Button.propTypes = {
    onClick: React.PropTypes.func,
    disabled: React.PropTypes.bool
}

module.exports = Button



// WEBPACK FOOTER //
// ./src/components/toolbar/button.jsx